import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1184da36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nodata-panel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-p-5 p-m-auto text-gray-1" }, "ไม่พบข้อมูล", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "card p-p-3 pointer" }
const _hoisted_6 = { class: "p-d-flex p-jc-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "หมายเลขคำสั่งซื้อ :", -1))
const _hoisted_8 = { class: "p-text-bold" }
const _hoisted_9 = { class: "f-size-12 text-gray-1 p-text-left" }
const _hoisted_10 = { class: "p-d-flex" }
const _hoisted_11 = {
  key: 0,
  class: "p-mr-2 p-my-2 p-ml-0"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = { class: "p-d-flex p-jc-between" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "สถานะ :", -1))
const _hoisted_16 = {
  key: 0,
  class: "text-blue"
}
const _hoisted_17 = {
  key: 1,
  class: "text-success"
}
const _hoisted_18 = {
  key: 2,
  class: "text-red"
}
const _hoisted_19 = { class: "p-d-flex p-jc-between" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "จำนวนสินค้า :", -1))
const _hoisted_21 = { class: "p-d-flex p-jc-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ราคา :", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.transactionList.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionList, (transaction, tindex) => {
        return (_openBlock(), _createElementBlock("div", { key: tindex }, [
          _createElementVNode("div", {
            class: "p-pb-2 p-px-3",
            onClick: ($event: any) => (_ctx.onSeeOrderDetail(transaction))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(transaction.invoiceNo), 1)
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.datetimeFormat(new Date(transaction.createdTime))), 1),
              _createElementVNode("div", _hoisted_10, [
                (
                transaction.products.length > 0 &&
                transaction.products[0].imageUrl
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("img", {
                        class: "product-image",
                        src: transaction.products[0].imageUrl,
                        alt: ""
                      }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    (
                    transaction.status !== 'จัดส่งเรียบร้อย' &&
                    transaction.status !== 'หมดอายุ' &&
                    transaction.status !== 'ยกเลิก'
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(transaction.status), 1))
                      : (transaction.status == 'จัดส่งเรียบร้อย')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(transaction.status), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(transaction.status), 1))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", null, _toDisplayString(Number(_ctx.productCount(transaction.products)).toLocaleString()) + " ชิ้น ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", null, _toDisplayString(Number(transaction.grandTotal).toFixed(2).toLocaleString()), 1)
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ]),
    _createVNode(_component_InfiniteLoading, {
      onInfiniteHandler: _ctx.infiniteHandler,
      class: "p-mt-4"
    }, null, 8, ["onInfiniteHandler"])
  ], 64))
}